import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useRendicontazione from '../../hooks/useRendicontazione'; // L'hook che abbiamo appena creato
import { Card, Form, Button, Table, Badge, Spinner, Alert } from 'react-bootstrap';
import useMediaQuery from '../../hooks/useMediaQuery';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { alertService } from '../../services/AlertService';
import { ROLES } from '../../model/roles';

const RendicontazionePage = () => {
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const userLoggedIn = useSelector(state => state.user.userData);

    // Usiamo il nostro nuovo hook
   const { loadingStateRendicontazione, getReportMensile, getStorico, getReportMensileSuperpartner, uploadFattura, getStoricoSuperpartner, uploadFatturaSuperpartner } = useRendicontazione();

    // Stati per gestire i filtri e i dati
    const dataMesePrecedente = new Date(new Date().setMonth(new Date().getMonth() - 1));
    const [selectedMonth, setSelectedMonth] = useState(dataMesePrecedente.getMonth() );
    const [selectedYear, setSelectedYear] = useState(dataMesePrecedente.getFullYear());    const [reportData, setReportData] = useState([]);
    const [totaleProvvigioni, setTotaleProvvigioni] = useState(0);
    const [storico, setStorico] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);


    // Funzione per caricare il report quando si clicca il pulsante
    /*
    const handleFetchReport = async (mese, anno) => {

        if (!userLoggedIn?.id_agenzia) {
            alertService.error("Dati dell'agenzia non trovati.");
            return;
        }

        // Eseguiamo entrambe le chiamate in parallelo per la massima efficienza
        await Promise.all([
            (async () => {
                const params = { mese, anno, id_agenzia: userLoggedIn.id_agenzia };
                const report = await getReportMensile(params);
                setReportData(report);
                const totale = report.reduce((sum, item) => sum + parseFloat(item.provvigione_partner || 0), 0);
                setTotaleProvvigioni(totale);
            })(),
            fetchStorico() // Richiamiamo fetchStorico per aggiornare lo stato
        ]);
    };
    */
// Sostituisci questa funzione nel tuo file RendicontazionePage.js

    const handleFetchReport = async (mese, anno) => {
        fetchStorico();
        let report = [];
        const params = { mese, anno };

        if (userLoggedIn.role === ROLES.SUPERPARTNER) {
            params.id_superpartner = userLoggedIn.id_superpartner;
            report = await getReportMensileSuperpartner(params);
        } else if (userLoggedIn.role === ROLES.PARTNER && userLoggedIn.id_agenzia) {
            params.id_agenzia = userLoggedIn.id_agenzia;
            report = await getReportMensile(params);
        } else {
            alertService.error("Dati utente non validi per generare il report.");
            setReportData([]);
            setTotaleProvvigioni(0);
            return;
        }

        const reportValido = Array.isArray(report) ? report : [];
        setReportData(reportValido);

        // --- NUOVA LOGICA PER IL CALCOLO DEL TOTALE ---
        let totale = 0;
        if (userLoggedIn.role === ROLES.SUPERPARTNER) {
            // Calcola il totale usando ESPLICITAMENTE il campo del superpartner
            totale = reportValido.reduce((sum, item) => sum + parseFloat(item.provvigione_superpartner || 0), 0);
        } else {
            // Calcola il totale usando ESPLICITAMENTE il campo del partner
            totale = reportValido.reduce((sum, item) => sum + parseFloat(item.provvigione_partner || 0), 0);
        }
        setTotaleProvvigioni(totale);
    };

    // Aggiungi questa funzione dopo handleFetchReport

    const handleUploadFattura = async () => {
        console.log("File selezionato prima dell'upload:", selectedFile);
        if (!selectedFile) {
            alertService.warn("Per favore, seleziona un file da caricare.");
            return;
        }

        const formData = new FormData();
        formData.append('mese', selectedMonth);
        formData.append('anno', selectedYear);
        formData.append('totale_provvigioni', totaleProvvigioni);
        formData.append('fattura', selectedFile);

        let success = false;

        // --- BIFORCAZIONE DELLA LOGICA ---
        if (userLoggedIn.role === ROLES.SUPERPARTNER && userLoggedIn.id_superpartner) {
            // NUOVA LOGICA: Se è un Superpartner, aggiunge l'id_superpartner
            formData.append('id_superpartner', userLoggedIn.id_superpartner);

            // --- AGGIUNGI QUESTO BLOCCO DI DEBUG ---
            console.log("--- Ispezionando FormData prima dell'invio ---");
            for (let [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            console.log("-----------------------------------------");
            // --- FINE BLOCCO DI DEBUG ---

            // E chiama una nuova funzione di upload dedicata nel hook
            success = await uploadFatturaSuperpartner(formData);

        } else if (userLoggedIn.role === ROLES.PARTNER && userLoggedIn.id_agenzia) {
            // LOGICA ESISTENTE: Se è un Partner, aggiunge l'id_agenzia
            formData.append('id_agenzia', userLoggedIn.id_agenzia);
            success = await uploadFattura(formData);
        } else {
            alertService.error("Dati utente non validi per il caricamento.");
            return;
        }

        if (success) {
            setSelectedFile(null);
            // Ricarica lo storico per mostrare il nuovo stato "Verifica Amministrativa"
            fetchStorico(); 
        }
    };

    const fetchStorico = async () => {
    // Esce subito se non ci sono i dati utente
        if (!userLoggedIn) return;

        let storicoData = [];

        if (userLoggedIn.role === ROLES.SUPERPARTNER && userLoggedIn.id_superpartner) {
            // NUOVA LOGICA: Se è un Superpartner, chiama una nuova funzione dedicata
            // che dovrai creare nel tuo hook 'useRendicontazione'.
            // Questa funzione si aspetterà l'id_superpartner.
            storicoData = await getStoricoSuperpartner({ id_superpartner: userLoggedIn.id_superpartner });

        } else if (userLoggedIn.role === ROLES.PARTNER && userLoggedIn.id_agenzia) {
            // LOGICA ESISTENTE: Se è un Partner, usa la funzione attuale.
            storicoData = await getStorico({ id_agenzia: userLoggedIn.id_agenzia });
        }

        setStorico(storicoData || []); // Assicurati che lo stato sia sempre un array
    };
    
    // Carica il report del mese precedente al primo caricamento della pagina
// SOSTITUISCI IL TUO useEffect con questo
    
    // Carica lo storico delle rendicontazioni al primo caricamento della pagina
    /*
    useEffect(() => {
        const fetchStorico = async () => {
            if (userLoggedIn?.id_agenzia) {
                const storicoData = await getStorico({ id_agenzia: userLoggedIn.id_agenzia });
                setStorico(storicoData);
            }
        };
        fetchStorico();
    }, [userLoggedIn]); // Si attiva quando le info dell'utente sono disponibili
    */
   // --- SOSTITUISCI TUTTI I TUOI useEffect CON QUESTO ---
    useEffect(() => {

        // Al primo caricamento o quando il mese/anno cambiano,
        // carica sia lo storico che il report del periodo selezionato.
        console.log(selectedMonth);
        const initialLoad = async () => {
            if (userLoggedIn?.id_agenzia && selectedMonth && selectedYear) {
                // Chiamiamo la nostra nuova funzione "tuttofare"
                await handleFetchReport(selectedMonth, selectedYear);
            }
        };
        initialLoad();
    }, [selectedMonth, selectedYear, userLoggedIn?.id_agenzia]); // Si attiva al cambio di data o utente


    const renderMonthsOptions = () => {
        const mesi = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

        const annoCorrente = new Date().getFullYear();
        const meseCorrente = new Date().getMonth(); // 0-11

        // Se l'anno selezionato è l'anno corrente, mostra solo i mesi passati
        if (parseInt(selectedYear) === annoCorrente) {
            // .slice(0, meseCorrente) estrae i mesi dall'inizio fino al mese precedente
            return mesi.slice(0, meseCorrente).map((mese, index) => (
                <option key={index + 1} value={index + 1}>{mese}</option>
            ));
        }

        // Altrimenti, se è un anno passato, mostra tutti i 12 mesi
        return mesi.map((mese, index) => (
            <option key={index + 1} value={index + 1}>{mese}</option>
        ));
    };

    const renderYearsOptions = () => {
        const annoCorrente = new Date().getFullYear();
        const anni = [];
        for (let i = annoCorrente; i >= annoCorrente - 5; i--) {
            anni.push(<option key={i} value={i}>{i}</option>);
        }
        return anni;
    };

        const getStatoBadge = (stato) => {
        switch (stato) {
            case 'Liquidato':
                return <Badge bg="success">Liquidato</Badge>;
            case 'Da Liquidare':
                return <Badge bg="primary">Da Liquidare</Badge>;
            case 'Verifica Amministrativa':
                return <Badge bg="warning" text="dark">in fase di verifica amministrativa</Badge>;
            case 'Liquidazione Sospesa':
                return <Badge bg="danger">Sospesa</Badge>;
            default:
                return <Badge bg="secondary">{stato}</Badge>;
        }
    };

    return (
        <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'p-3'}`}>
            <div className="d-flex justify-content-between custom-card-header">
                <div className="d-flex gap-3 custom-card-title my-2">
                    <div className="custom-icon-container">
                        <i className="bi bi-graph-up-arrow fs-2"></i>
                    </div>
                    <div className="align-self-center">
                        <span className="fs-4 d-block"><i><b>Rendicontazione Provvigioni</b></i></span>
                    </div>
                </div>
            </div>

            <Card className="mt-5">
                <Card.Body>
                    <Card.Title>Seleziona Periodo</Card.Title>
                    <div className="row g-3 align-items-end">
                        <div className="col-md-5">
                            <Form.Label>Mese</Form.Label>
                            <Form.Select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                                {renderMonthsOptions()}
                            </Form.Select>
                        </div>
                      <div className="col-md-6">
                        <Form.Select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                            {renderYearsOptions()}
                        </Form.Select>
                    </div>  
                    </div>
                </Card.Body>
            </Card>

            <div className="mt-4">
                {loadingStateRendicontazione.isLoadingReport ? (
                    <div className="text-center p-5"><Spinner animation="border" /></div>
                ) : reportData.length > 0 ? (
                    <>
                        <Table striped bordered hover responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>Corsista</th>
                                    <th>Corso</th>
                                    <th>Data Iscrizione</th>
                                    <th className="text-end">Provvigione</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportData.map(item => (
                                    <tr key={item.id_classe_utente}>
                                        {/* NUOVO DATO CONDIZIONALE */}
                                        {userLoggedIn.role === ROLES.SUPERPARTNER && <td>{item.denominazione_agenzia}</td>}
                                        <td>{item.corsista_cognome} {item.corsista_nome}</td>
                                        <td>{item.denominazione_corso}</td>
                                        <td>{UtilityService.formatDate(item.data_iscrizione)}</td>
                                         <td className="text-end">€ {parseFloat(item.provvigione_superpartner || item.provvigione_partner || 0).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
{/* --- SOSTITUISCI IL VECCHIO BLOCCO <Alert> CON QUESTO --- */}
{/* --- BLOCCO RIEPILOGO POTENZIATO --- */}
<div className="mt-4">
    <Alert variant="success">
        <div className="d-flex justify-content-between align-items-center">
            <span className="fs-5">Totale Provvigioni per il periodo selezionato:</span>
            <strong className="fs-4">€ {totaleProvvigioni.toFixed(2)}</strong>
        </div>
    </Alert>

    {/* Logica condizionale per mostrare lo stato o il form di upload */}
    {(() => {
        const rendicontazioneMeseCorrente = storico.find(s => s.mese == selectedMonth && s.anno == selectedYear);

        // CASO 1: Esiste già una rendicontazione per questo mese
        if (rendicontazioneMeseCorrente) {
            return (
                <Card className="mt-2">
                    <Card.Header>Stato Liquidazione per {selectedMonth}/{selectedYear} - Data aggiornamento: {new Date(rendicontazioneMeseCorrente.data_aggiornamento).toLocaleString('it-IT')}</Card.Header>
                    <Card.Body>
                        <div className="d-flex align-items-center">
                            <span className="me-2">Stato attuale:</span>
                            {getStatoBadge(rendicontazioneMeseCorrente.stato)}
                        </div>

                        {/* Se lo stato è 'Verifica Amministrativa', mostra la nota esplicativa */}
                        {rendicontazioneMeseCorrente.stato === 'Verifica Amministrativa' && (
                            <small className="d-block text-muted mt-2">
                                La fattura è in fase di verifica. In caso di incongruenze, riceverai una nota e potrai ricaricare una versione corretta da questa schermata.
                            </small>
                        )}

                        {/* --- NUOVO BLOCCO PER LIQUIDAZIONE SOSPESA --- */}
                        {rendicontazioneMeseCorrente.stato === 'Liquidazione Sospesa' && (
                            <div className="mt-3">
                                <Alert variant="danger">
                                    <Alert.Heading as="h6">Motivazione della Sospensione:</Alert.Heading>
                                    <p className="mb-0 fst-italic">"{rendicontazioneMeseCorrente.note}"</p>
                                </Alert>
                                <hr />
                                <p className="text-muted">Per favore, correggi la fattura e caricala di nuovo per sottoporla a una nuova verifica.</p>
                                <Form.Group>
                                    <Form.Label>Carica Nuova Fattura (PDF)</Form.Label>
                                    <Form.Control type="file" accept=".pdf" onChange={(e) => setSelectedFile(e.target.files[0])} />
                                </Form.Group>
                                <div className="text-end mt-3">
                                    <Button variant="warning" onClick={handleUploadFattura} disabled={!selectedFile || loadingStateRendicontazione.isUploadingFattura}>
                                        {loadingStateRendicontazione.isUploadingFattura ? <Spinner as="span" size="sm" /> : "Invia Nuova Fattura"}
                                    </Button>
                                </div>
                            </div>
                        )}
                        {/* --- FINE NUOVO BLOCCO --- */}

                        {/* --- NUOVO BLOCCO PER DA LIQUIDARE --- */}
                        {rendicontazioneMeseCorrente.stato === 'Da Liquidare' && (
                            <div className="mt-3">
                                 <Alert variant="primary" className="mt-3">
                                    <Alert.Heading as="h6"><i className="bi bi-check2-circle me-2"></i>Fattura Approvata</Alert.Heading>
                                    <p className="mb-0">
                                        L'amministrazione ha verificato la regolarità della fattura e provvederà alla sua liquidazione.
                                        <br/>
                                        Effettuata la liquidazione, troverai qui in allegato copia della disposizione di pagamento.
                                    </p>
                                </Alert>
                            </div>
                        )}
                        {/* --- FINE NUOVO BLOCCO --- */}

                        {/* --- NUOVO BLOCCO PER LIQUIDATO --- */}
                        {rendicontazioneMeseCorrente.stato === 'Liquidato' && (
                            <div className="border-top pt-3 mt-3">
                                <p className="mb-2"><strong>Scarica la copia dell'avvenuto pagamento</strong></p>
                                <a href={rendicontazioneMeseCorrente.path_ricevuta_pagamento} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-sm d-inline-flex align-items-center">
                                    <i className="bi bi-download me-2"></i>
                                    <span>Data pagamento: {UtilityService.formatDate(rendicontazioneMeseCorrente.data_liquidazione)}</span>
                                </a>
                            </div>
                        )}
                        {/* --- FINE NUOVO BLOCCO --- */}
                        
                    </Card.Body>
                </Card>
            );
        } 

        // CASO 2: Non esiste una rendicontazione, ma ci sono provvigioni da liquidare
        if (totaleProvvigioni > 0) {
            return (
                <Card className="mt-2 border-primary">
                    <Card.Body>
                        <Card.Title>Richiedi Liquidazione</Card.Title>
                        <p className="text-muted">Per procedere, carica la fattura relativa a questo periodo.</p>
                        <Form.Group>
                            <Form.Label>Carica Fattura (PDF)</Form.Label>
                            <Form.Control type="file" accept=".pdf" onChange={(e) => setSelectedFile(e.target.files[0])} />
                        </Form.Group>
                        <div className="text-end mt-3">
                            <Button variant="primary" onClick={handleUploadFattura} disabled={!selectedFile || loadingStateRendicontazione.isUploadingFattura}>
                                {loadingStateRendicontazione.isUploadingFattura ? <Spinner as="span" size="sm" /> : "Invia per la verifica"}
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            );
        }

        // CASO 3: Nessuna provvigione da liquidare (non mostra nulla)
        return null;
    })()}
</div>
                    </>
                ) : (
                    <Alert variant="secondary" className="mt-4">Nessuna provvigione maturata per il periodo selezionato.</Alert>
                )}
            </div>
        </div>
    );
};

export default RendicontazionePage;